import { Alert, AlertProps } from '@brokerbay/design-components';
import React from 'react';
import { LayoutContext } from 'contexts';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Property } from 'csstype';
import { BANNER_HEIGHT, MOBILE_BANNER_HEIGHT } from './constants';
import { otherElementSum } from './utils';

interface BannerAlertProps extends AlertProps {
  backgroundColor: Property.BackgroundColor;
}

const BannerAlert = ({ backgroundColor, ...rest }: BannerAlertProps) => {
  const { topElementHeights, isMobileView } = React.useContext(LayoutContext);

  const offsetTop = React.useMemo(
    () => otherElementSum(topElementHeights),
    [topElementHeights],
  );

  return (
    <StyledAlert
      showIcon={false}
      banner
      $backgroundColor={backgroundColor}
      $assumeVisible={offsetTop > 0}
      $isMobileView={isMobileView}
      {...rest}
    />
  );
};

export default BannerAlert;

const StyledAlert = styled(Alert)<{
  $assumeVisible: boolean;
  $backgroundColor: Property.BackgroundColor;
  $isMobileView: boolean;
}>`
  ${({ $backgroundColor }) =>
    $backgroundColor && `background-color: ${$backgroundColor} !important;`}
  ${({ $isMobileView }) =>
    $isMobileView
      ? `height: ${MOBILE_BANNER_HEIGHT}px;`
      : `height: ${BANNER_HEIGHT}px;`}

  align-items: center !important; // Required to override base component's alignment
  // The BrokerBay assume bar has the same color as the banner, this is just to help distinguish between the two banners
  ${({ $assumeVisible }) => $assumeVisible && `border-top: 1px solid black;`}
`;
